module.exports = __webpack_public_path__ + "img/dark_blonde.5ef7e786.svg";